/**
 * Dynamic API URL resolver
 * Automatically detects the current domain and returns the appropriate API URL
 */
import { getCurrentConfig, logEnvironmentConfig } from './environmentConfig';

/**
 * Get the appropriate API URL based on the current domain
 */
export const getApiUrl = (): string => {
  const config = getCurrentConfig();
  return config.apiUrl;
};

/**
 * Log the current API configuration for debugging
 */
export const logApiConfig = (): void => {
  logEnvironmentConfig();
};
